export enum AuthEnum {
    LOGIN = "login",
    LOGOUT = "logout",
    API = "api",
    API_TOKEN_AUTH = "api-token-auth"
}